import { type ModuleData, ModuleProvider, useModule } from '#providers'
import { ForwardedProperties } from './Bank'

export interface BankConfig {
	isProduction: boolean
	forwardedProperties: ForwardedProperties
	clientName: string
}

interface BankData {}

export type BankModuleData = ModuleData<BankData, void, BankConfig>

export const BankModuleProvider: typeof ModuleProvider<BankModuleData> =
	ModuleProvider

export const useBankModule: typeof useModule<BankModuleData> = useModule
